    <header class="page-head">
      <div>
        <h1 class="page-title">Get Help</h1>
        <p class="page-subtitle">Browse FAQs, request a callback, start WhatsApp help, or log a support request.</p>
      </div>
    </header>

    <section class="support-grid">
      <div class="faq-card span-5">
        <h2 class="section-title">FAQs</h2>
        <ul class="faq-list">
          <li>How do I notify linked institutions after a SIM swap?</li>
          <li>When will contact and message backups sync?</li>
          <li>How do disputes on unknown accounts work?</li>
        </ul>
      </div>

      <div class="detail-card span-7">
        <form class="form-stack" [formGroup]="supportForm">
          <div class="field-grid">
            <div class="input-group">
              <label>Request a call back</label>
              <input formControlName="callbackNumber" placeholder="Preferred phone number" />
            </div>
            <div class="input-group">
              <label>WhatsApp help</label>
              <input formControlName="whatsAppNumber" placeholder="WhatsApp contact number" />
            </div>
            <div class="input-group span-12">
              <label>Support request</label>
              <textarea formControlName="supportRequest" placeholder="Describe the issue you need help with"></textarea>
            </div>
          </div>
          <div class="btn-row">
            <button class="btn btn-primary" type="button">Submit support request</button>
            <button class="btn btn-secondary" type="button">Request call back</button>
          </div>
        </form>
      </div>
    </section>
